import { TranslateLoader } from '@ngx-translate/core';
import en from '@src/assets/i18n/en-US.json';
import es from '@src/assets/i18n/es-ES.json';
import pt from '@src/assets/i18n/pt-BR.json';
import { Observable, of } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translations: { [key: string]: any } = {
  'en-US': en,
  'pt-BR': pt,
  'es-ES': es,
};

export class CustomTranslateLoader implements TranslateLoader {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTranslation(lang: string): Observable<any> {
    return of(translations[lang] || {});
  }
}
